export const BASE_URL = 'http://localhost:3001'
// export const BASE_URL = 'https://wikibean-api.herokuapp.com/'

export const DATABASE_URL = 'postgresql-rectangular-35514'
